(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ice-product"] && !Shopify.designMode) return;
  try {
    
  function initIceBuy(root){
    if(root.dataset.ready==='true')return;root.dataset.ready='true';
    const media=[...root.querySelectorAll('[data-media-index]')];
    const thumbs=[...root.querySelectorAll('[data-gallery-thumbnail]')];
    const count=root.querySelector('[data-gallery-count]');
    let current=0;
    const showMedia=index=>{if(!media.length)return;current=(index+media.length)%media.length;media.forEach((item,i)=>{item.hidden=i!==current;item.classList.toggle('is-active',i===current);if(i!==current)item.querySelector('video')?.pause()});thumbs.forEach((item,i)=>{item.classList.toggle('is-active',i===current);item.setAttribute('aria-current',String(i===current))});if(count)count.textContent=`${current+1} / ${media.length}`};
    root.querySelector('[data-gallery-previous]')?.addEventListener('click',()=>showMedia(current-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>showMedia(current+1));
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showMedia(index)));
    const radios=[...root.querySelectorAll('[data-variant-radio]')];
    const price=root.querySelector('[data-product-price]');
    const stickyPrice=root.querySelector('[data-sticky-price]');
    const compare=root.querySelector('[data-product-compare]');
    const submit=root.querySelector('[data-product-submit]');
    const stickySubmit=root.querySelector('[data-sticky-submit]');
    const submitLabel=root.querySelector('[data-product-submit-label]');
    radios.forEach(radio=>radio.addEventListener('change',()=>{
      radios.forEach(item=>item.closest('.ice-buy__bundle')?.classList.toggle('is-selected',item.checked));
      if(price)price.textContent=radio.dataset.price;
      if(stickyPrice)stickyPrice.textContent=radio.dataset.price;
      if(compare){compare.textContent=radio.dataset.compare;compare.hidden=radio.dataset.onSale!=='true'}
      const available=radio.dataset.available==='true';
      if(submit)submit.disabled=!available;
      if(stickySubmit)stickySubmit.disabled=!available;
      if(submitLabel)submitLabel.textContent=available?root.dataset.addLabel:root.dataset.soldLabel;
      const mediaIndex=media.findIndex(item=>item.dataset.mediaId===radio.dataset.mediaId);
      if(mediaIndex>=0)showMedia(mediaIndex);
      const url=new URL(location.href);url.searchParams.set('variant',radio.value);history.replaceState({},'',url);
    }));
    const sticky=root.querySelector('[data-product-sticky]');
    if(sticky&&submit&&'IntersectionObserver'in window){new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting},{threshold:0}).observe(submit)}
  }
  document.querySelectorAll('[data-ice-buy]').forEach(initIceBuy);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ice-buy]').forEach(initIceBuy));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
